import React from 'react';
import { SwitchContainer, SwitchLabel } from './style';
import AntSwitch from '../../components/FeedbacksComponents/AntSwitch';

const ToggleSwitchWithOneOption = ({
  text = null,
  onChecked,
  onChangeFn,
  disabled = false,
  ariaLabel,
}) => {
  return (
    <SwitchContainer showBorder={text}>
      {text && <SwitchLabel>{text}</SwitchLabel>}
      <AntSwitch
        checked={onChecked}
        onChange={onChangeFn}
        disabled={disabled}
        inputProps={ariaLabel ? { 'aria-label': ariaLabel } : undefined}
      />
    </SwitchContainer>
  );
};

export default ToggleSwitchWithOneOption;
